<template>
  <div class="admin-panel">
    <div class="loader" v-if="loading"><div class="spinner"></div></div>
    <p class="hint">Редактируется раздел GtpProvider &rarr; YandexResponsesApi &rarr; body (модель, промпт, параметры file_search). Изменения применяются сразу после сохранения, без перезапуска.</p>
    <textarea v-model="bodyText" class="json-editor" rows="20" spellcheck="false"></textarea>
    <div class="actions">
      <button @click="reload">Отменить изменения</button>
      <button class="primary" @click="save">Сохранить</button>
    </div>
    <p v-if="error" class="error">{{ error }}</p>

    <hr class="divider" />

    <p class="hint">Редактируется раздел GtpProvider &rarr; Common (общие настройки, не привязанные к конкретному провайдеру). Изменения сохраняются в appsettings.json.</p>
    <textarea v-model="commonText" class="json-editor" rows="10" spellcheck="false"></textarea>
    <div class="actions">
      <button @click="reloadCommon">Отменить изменения</button>
      <button class="primary" @click="saveCommon">Сохранить</button>
    </div>
    <p v-if="commonError" class="error">{{ commonError }}</p>
  </div>
</template>

<script>
import { adminApi } from '../api/admin-api';
import Vue from 'vue';

export default {
  name: 'settings-editor',
  data() {
    return {
      bodyText: '',
      loading: false,
      error: '',

      commonText: '',
      commonError: '',
    };
  },
  methods: {
    async reload() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await adminApi.get('/settings/body');
        this.bodyText = JSON.stringify(data, null, 2);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      let parsed;
      try {
        parsed = JSON.parse(this.bodyText);
      } catch (e) {
        this.error = 'Некорректный JSON: ' + e.message;
        return;
      }

      this.error = '';
      this.loading = true;
      try {
        await adminApi.put('/settings/body', parsed);
        Vue.toasted.show('Настройки сохранены и применены', { type: 'success', duration: 3000 });
      } finally {
        this.loading = false;
      }
    },
    async reloadCommon() {
      this.loading = true;
      this.commonError = '';
      try {
        const { data } = await adminApi.get('/settings/common');
        this.commonText = JSON.stringify(data, null, 2);
      } finally {
        this.loading = false;
      }
    },
    async saveCommon() {
      let parsed;
      try {
        parsed = JSON.parse(this.commonText);
      } catch (e) {
        this.commonError = 'Некорректный JSON: ' + e.message;
        return;
      }

      this.commonError = '';
      this.loading = true;
      try {
        await adminApi.put('/settings/common', parsed);
        Vue.toasted.show('Настройки сохранены', { type: 'success', duration: 3000 });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.reload();
    this.reloadCommon();
  }
};
</script>

<style scoped>
.admin-panel {
  position: relative;
  padding: 10px;
}

.hint {
  font-size: 12px;
  color: #666;
}

.json-editor {
  width: 100%;
  box-sizing: border-box;
  font-family: monospace;
  font-size: 12px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

button {
  cursor: pointer;
}

button.primary {
  background: #f15540;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 8px 14px;
}

.error {
  color: #d94a36;
  font-size: 12px;
}

.divider {
  margin: 25px 0;
  border: none;
  border-top: 1px solid #e0e0e0;
}

.loader {
  position: absolute;
  top: 10px;
  right: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(0,0,0,0.1);
  border-left-color: #e74c3c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/settings-editor.vue